import React from 'react'

import cashEventImage from '@assets/images/cashflow_event_image.png'

import { BackToDashboardButton } from '../../Components/BackToDashboardButton'
import { RefreshButton } from '../../Components/RefreshButton'

export const Consent = () => {
  return (
    <div className='astute-request-wrapper'>
      <h1>Awaiting digital consent</h1>
      <p className='astute-request-wrapper--subheading'>
        Astute have requested consent from your client
      </p>
      <img
        src={cashEventImage}
        alt='astute pending graphic'
        className='astute-request-wrapper--graphic'
      />
      <p className='astute-request-wrapper--link-text'>
        Once your client approves the request, we'll be able to generate the Astute report. The digital consent link expires in 24 hours.
      </p>
      <div className='astute-back-to-dashboard'>
        <BackToDashboardButton />
        <div className='refresh-button-wrapper'>
          <RefreshButton />
        </div>
      </div>
    </div>
  )
}
